<template>
  <div v-if="isOtpVerification">
    <generic-modal
      :height="LoginModalDim.height"
      :width="LoginModalDim.width"
      :padding="LoginModalDim.padding"
      :modalClass="LoginModalDim.modalClass"
      overflowNotNeeded="true"
    >
      <template v-slot:header>
        <div class="header-component mb15 flex-row plr16">
          <skip-login :skip-text="'Skip'" />
        </div>
        <div class="plr16">
          <img
            :src="staticImgBaseUrl + '/images/global/loginLogoHK.svg'"
          /></div
      ></template>
      <template v-slot:body>
        <div class="plr16 mt24">
          <div class="mb4 fs-14">
            <back-arrow @handleBackClick="handleBackClick" />
            <span class="pl8 bold">{{ modulePropsData?.headingText }}</span>
          </div>
          <!-- <div class="login-benefit-text" v-if="showLoggingIn">
            {{ modulePropsData?.loggingInText }} &nbsp;
            <div class="loading-sm"></div>
          </div>
          <div class="login-benefit-text" v-else-if="invalidOtp">
            {{ modulePropsData?.wrongOtpText }}
          </div>
          <div class="login-benefit-text" v-else>
            {{ modulePropsData?.enterOtpText }}
          </div> -->
          <div class="otp-input-container">
            <otp-input
              ref="otpInput"
              class="gap16"
              :input-classes="invalidOtp ? 'otp-input invalid' : 'otp-input'"
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              input-type="number"
              v-model="otpValue"
              separator=""
              @on-change="handleOnChange"
              @on-complete="handleOnChange"
            />
          </div>
          <div v-if="invalidOtp" class="otp-invalid-text">
            {{ modulePropsData?.incorrectOtpTryAgainText }}
          </div>
          <div
            v-if="!invalidOtp"
            class="otp-sent-text"
            :class="{ mt18: invalidOtp }"
          >
            {{ modulePropsData?.otpSentInfoText }} {{ mobileNo }}&nbsp;
            <span
              @click="handleBackClick($event)"
              class="color-teal-secondary bold"
              >{{ modulePropsData?.changeNumberCtaText }}</span
            >
          </div>
          <div v-if="disableResendSMS" class="resend-sms-counter">
            <span class="resend-sms-disabled">{{
              modulePropsData?.resendOtpCtaText
            }}</span
            >&nbsp;in
            {{ prettifyTimer(timerCount) }}
          </div>
          <span
            v-if="!disableResendSMS"
            class="resend-sms-enabled color-teal-secondary"
            @click="handleResendSMS($event)"
            >{{ modulePropsData?.resendOtpCtaText }}</span
          >
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="login-button bold"
          :class="{ 'color-white': disableLogin }"
          :disabled="disableLogin"
          @click="handleSubmitOTP($event)"
        >
          {{ modulePropsData?.submitOtpButtonText }}
        </button>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import OtpInput from "./reusableComponents/OtpInput.vue"
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { LoginStates, LoginStateStatus } from "../helpers/loginStateConstants";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
import {
  EVENT_CLICK_CHANGEMOBILENUMBER,
  EVENT_CLICK_RESENDSMS,
  EVENT_TYPE_OTP,
} from "../helpers/analyticsEvents";
import { autoReadSMS } from "../helpers/loginUtils";
import BackArrow from "./BackArrow.vue";

export default {
  name: "OtpVerification",
  components: {
    OtpInput,
    GenericModal,
    BackArrow,
  },
  props: {
    // counterLimit is time in seconds for timer
    adDisable: false,
    moduleProps: {},
  },
  data() {
    return {
      LoginModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "login-modal full-screen-popup lg-screen-centered",
      },
      timerCount: 0,
      otpValue: "",
      otpEnterEventProcessed: false,
      modulePropsData: {},
      clientPlatform,
      staticImgBaseUrl,
      counterLimit: 0,
      otpVerificationTriggerred: false,
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (!this.autoReadDisable) {
              autoReadSMS((otp, signal) => {
                if (otp) {
                  this.otpValue = otp;
                  this.$refs.otpInput.otp = otp.split("");
                  this.autoReadDisable = true;
                  if (otp.length == 6) {
                    this.handleSubmitOTP();
                  }
                  signal.abort();
                }
              });
            }
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.counterLimit =
      this.modulePropsData?.timeCount || this.modulePropsData?.timerCount;
  },
  methods: {
    resetTimer() {
      this.timerCount = this.counterLimit;
    },
    handleOnChange(value) {
      if (this.otpValue && !this.otpEnterEventProcessed) {
        this.otpEnterEventProcessed = true;
        EVENT_TYPE_OTP({ loginMethod: "manual" });
      }
      if (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      ) {
        this.$store.commit(keyMapsMutation.UPDATE_LOGIN_STATE_STATUS, "");
      }
      this.otpValue = value;
      if (value.length === 6) {
        this.handleSubmitOTP();
      }
    },
    handleResendSMS(e) {
      EVENT_CLICK_RESENDSMS({ loginMethod: "manual" });
      this.otpValue = "";
      this.resetTimer();
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
        setTimeout(() => {
          this.$store.dispatch(keyMapsAction.FORGOT_PASSWORD_API, {
            mobile: LocalStorageFunc.getUserMobileNo(),
            hash: this.hashKey?.key,
            id: this.hashKey?.id,
          });
        }, 1000);
      });
    },
    handleSubmitOTP(e) {
      if (!this.otpVerificationTriggerred) {
        this.otpVerificationTriggerred = true;
        this.$store.dispatch(keyMapsAction.VALIDATE_OTP_API, {
          mobile: LocalStorageFunc.getUserMobileNo(),
          code: this.otpValue,
          screenName: "LOGIN",
          autologin: !e,
        });
      }
    },
    handleBackClick(e) {
      clearTimeout(this.timerCount);
      const { getFPInstance } = fingerPrintInstance;
      collectData({ detector: getFPInstance() }).then((response) => {
        const payload = {
          detectorData: response,
        };
        this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
      });
      this.$store.commit(keyMapsMutation.UPDATE_LOCAL_STORAGE_USER_DATA, {
        mobile: "",
      });
      this.$store.commit(keyMapsMutation.UPDATE_LOGIN_STATE_STATUS, "");
      EVENT_CLICK_CHANGEMOBILENUMBER({ loginMethod: "manual" });
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
        LoginStates.welcomeLogin
      );
    },
    prettifyTimer(value) {
      let minutes = value > 59 ? Math.trunc(value / 60) : 0;
      let secondes = value % 60;
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (secondes < 10) {
        secondes = "0" + secondes;
      }
      return minutes + ":" + secondes;
    },
  },
  computed: {
    disableResendSMS() {
      return this.timerCount > 0;
    },
    disableLogin() {
      return (
        this.otpValue.length < 6 ||
        this.$store.state.Auth.loginStateStatus ==
          LoginStateStatus.VALIDATING_OTP ||
        this.$store.state.Auth.loginStateStatus ==
          LoginStateStatus.VALIDATED_OTP_INVALID
      );
    },
    mobileNo() {
      return this.$store.state.Auth.mobileNo;
    },
    showLoggingIn() {
      return (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATING_OTP
      );
    },
    invalidOtp() {
      if (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      ) {
        this.otpVerificationTriggerred = false;
      }
      return (
        this.$store.state.Auth.loginStateStatus ==
        LoginStateStatus.VALIDATED_OTP_INVALID
      );
    },
    hashKey() {
      return this.$store.state.FingerPrint.hashKey;
    },
    isOtpVerification() {
      let flag =
        clientPlatform == "Web"
          ? this.$store.state.Auth.currentLoginState ===
              LoginStates.otpVerification &&
            this.$store.state.Auth.showProfileDrawerModal
          : this.$store.state.Auth.currentLoginState ===
            LoginStates.otpVerification;
      if (flag) {
        this.timerCount = this.counterLimit;
      }
      return flag;
    },
  },
};
</script>
